export default {
    METHOD: "Метод"
};
